import React from 'react';
import { Calendar, Award, TrendingUp } from 'lucide-react';

const OurHistory = () => {
  const milestones = [
    {
      year: '1976',
      title: 'The Beginning',
      description: 'SKYHIGH Adventures (formerly Balloon Safaris Limited) was launched by Alan Root from Keekerok Lodge, becoming the pioneers of hot air ballooning in Uganda.'
    },
    {
      year: '1980s',
      title: 'Expansion & Growth',
      description: 'Our reputation for excellence grew as we expanded our fleet and welcomed guests from around the world to experience the magic of Uganda from above.'
    },
    {
      year: '2000s',
      title: 'International Recognition',
      description: 'Our expertise and commitment to excellence gained international recognition, attracting the world\'s most experienced pilots to join our team.'
    },
    {
      year: 'Today',
      title: '48+ Years of Excellence',
      description: 'Led by Brenda J. Bakiza, we continue to operate with the same passion and commitment to safety that defined our founding, now with over 48 years of experience.'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      <section
        className="relative h-96 flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1588607756517-648eddc00a35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwc3VucmlzZSUyMHNhdmFubmFofGVufDB8fHx8MTc2MzA3MTEwMHww&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold">Our History</h1>
          <p className="text-xl mt-4">Pioneers since 1976</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-8">
            From the pioneers of ballooning in Uganda
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            As the pioneers of hot air balloon safaris in Uganda, SKYHIGH Adventures expertise and local knowledge is sought after and respected.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Founded in 1976, we have been operating for more than 48 years in Uganda. Our team of international pilots have a combined experience of thousands of hours flying hot air balloons commercially all over the world.
          </p>
        </div>
      </section>

      <section className="py-16 px-4 text-white" style={{ backgroundColor: '#EE6A1F' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <Calendar className="w-12 h-12 mx-auto mb-4" />
              <div className="text-5xl font-bold mb-2">48+</div>
              <p className="text-xl">Years of Operation</p>
            </div>
            <div>
              <Award className="w-12 h-12 mx-auto mb-4" />
              <div className="text-5xl font-bold mb-2">1000s</div>
              <p className="text-xl">Combined Pilot Hours</p>
            </div>
            <div>
              <TrendingUp className="w-12 h-12 mx-auto mb-4" />
              <div className="text-5xl font-bold mb-2">1st</div>
              <p className="text-xl">Pioneers in Uganda</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">Our Journey</h2>
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div key={index} className="flex flex-col md:flex-row gap-6">
                <div className="md:w-32 flex-shrink-0">
                  <div className="text-3xl font-bold" style={{ color: '#EE6A1F' }}>{milestone.year}</div>
                </div>
                <div className="flex-1">
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">{milestone.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{milestone.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-stone-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-8">Looking Forward</h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Under the leadership of Brenda J. Bakiza, we remain committed to the principles that have guided us for over 48 years: safety, expertise, service, and trust. The adventure continues, and we invite you to be part of our story.
          </p>
        </div>
      </section>
    </div>
  );
};

export default OurHistory;
